export default __webpack_public_path__ + "static/explainable-ai-2025-1-68317f11ddd34b1959540ae29824243e.jpg";